import { InteractionType } from "@azure/msal-browser"
import { MsalAuthenticationTemplate } from "@azure/msal-react"
import type { ReactNode } from "react"

export function RequireAuth({ children }: { readonly children: ReactNode }) {
  const authRequest = {
    scopes: ["openid", "profile"],
  }

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
    >
      <>{children}</>
    </MsalAuthenticationTemplate>
  )
}
